<template>
    <div class="dashboard-page">
        <div class="left">
            <h3>Dashboard</h3>
            <form>
                <div class="activePlaceholderImitation">
                    <datepicker
                        v-model="startDate"
                        calendar-class='calendar'
                        :disabled-dates="{from: new Date(endDate)}"
                        :use-utc='true'
                        @input="getData"
                    ></datepicker>
                    <span>Start date</span>
                </div>

                <div class="activePlaceholderImitation">
                    <datepicker
                        v-model="endDate"
                        calendar-class='calendar'
                        :disabled-dates="{to: new Date(startDate)}"
                        :use-utc='true'
                        @input="getData"
                    ></datepicker>
                    <span>End date</span>
                </div>

                <div class="plusMinusDay">
                    <div class="minus" @click="changeDay('subtract')">
                        <div></div>
                    </div>
                    <div class="plus" @click="changeDay('add')">
                        <div></div>
                    </div>
                    <span>Days</span>
                </div>

                <div 
                    class="refresh" 
                    @click="getData">
                </div>
            </form>
            <div class="donuts">
                <donutChart
                    :class="{'loading':chartsLoading[0],'hideLegend':!chartsShowLegends[0]}"
                    :series="seriesTreasures"
                    :labels="chartsLabels.treasures"
                    :name="chartsNames[0]"
                    :colors="treasuresColors"
                />
                <donutChart
                    :class="{ 'loading':chartsLoading[1],'hideLegend':!chartsShowLegends[1]}"
                    :series="seriesAllTransactions"
                    :labels="chartsLabels.standard"
                    :name="chartsNames[1]"
                    :colors="standardColors"
                />
                <donutChart
                    :class="{ 'loading':chartsLoading[2],'hideLegend':!chartsShowLegends[2]}"
                    :series="seriesSmallTransactions"
                    :labels="chartsLabels.standard"
                    :name="chartsNames[2]"
                    :colors="standardColors"
                />
                <donutChart
                    :class="{ 'loading':chartsLoading[3],'hideLegend':!chartsShowLegends[3]}"
                    :series="seriesLargeTransactions"
                    :labels="chartsLabels.standard"
                    :name="chartsNames[3]"
                    :colors="standardColors"
                />
            </div>
        </div>
        <div class="right">
            <div class="threeButtons" 
                v-show="seriesAllTransactions.length != 0"
                :class="{'transparent':seriesAllTransactions.length == 0}"
                >
                <div :class="{'active' : transactionsSize == 'All'}" @click="handeTransactionsSize('All')">All</div>
                <div :class="{'active' : transactionsSize == 'Small'}" @click="handeTransactionsSize('Small')">Small</div>
                <div :class="{'active' : transactionsSize == 'Large'}" @click="handeTransactionsSize('Large')">Large</div>
            </div>

            <sankeyChart 
                :class="{'transparent':seriesAllTransactions.length == 0 , 'loading':chartsLoading[4]}"
                :transactions="selectedTransactions" 
                :darkTheme="darkTheme"
            />
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import donutChart from './donutChart'
import sankeyChart from './sankeyChart'

export default {
    name: 'Dashboard',
    props:['darkTheme'],
    components: {
        Datepicker,
        donutChart,
        sankeyChart
    },
    data: () => ({
        chartsLoading:[false,false,false,false,false],
        transactionsSize:'Large',
        startDate: new Date().toUTCString(),
        endDate: new Date().toUTCString(),
        chartsLabels:{
            treasures: ["Mint", "Burn"],
            standard: ["Bullish", "Bearish"],
        },
        chartsColors:{
            treasures: ['#70DFB7', '#B0B7F4','#ffffff'],
            standard:['#78C4E4', '#F8E2AC','#ffffff'],
        },
        chartsColorsDark:{
            treasures: ['#179869', '#2D395F','#171a25'],
            standard:['#0067C7', '#720E2D','#171a25'],
        },
        allTransactions:{},
        smallTransactions:{},
        largeTransactions:{}
    }),
    computed:{
        seriesTreasures(){
            let seriesArr = [0,0];
            if (this.allTransactions.general){
                if (this.allTransactions.general.summary[1]){
                    let dataObj = this.allTransactions.general.summary[1];
                    if (dataObj.token == 'stable' && dataObj.mint && dataObj.burn)
                        seriesArr = [dataObj.mint,dataObj.burn];
                }
            }
            return seriesArr;
        },
        seriesAllTransactions(){
            let seriesArr = [0,0];
            if (this.allTransactions.general){
                if (this.allTransactions.general.summary[0] && this.allTransactions.general.summary[1]){
                let dataCryptoObj = this.allTransactions.general.summary[0];
                let dataStableObj = this.allTransactions.general.summary[1];
                if (dataCryptoObj.inbound && dataStableObj.inbound)
                    seriesArr = [dataStableObj.inbound, dataCryptoObj.inbound];
                }
            }
            return seriesArr;
        },
        seriesSmallTransactions(){
            let seriesArr = [0,0];
            if (this.smallTransactions.general){
                if (this.smallTransactions.general.summary[0] && this.smallTransactions.general.summary[1]){
                    let dataCryptoObj = this.smallTransactions.general.summary[0];
                    let dataStableObj = this.smallTransactions.general.summary[1];
                    if (dataCryptoObj.inbound && dataStableObj.inbound)
                        seriesArr = [dataStableObj.inbound, dataCryptoObj.inbound];
                }
            }
            return seriesArr;
        },
        seriesLargeTransactions(){
            let seriesArr = [0,0];
            if (this.largeTransactions.general){
                if (this.largeTransactions.general.summary[0]&& this.largeTransactions.general.summary[1]){
                    let dataCryptoObj = this.largeTransactions.general.summary[0];
                    let dataStableObj = this.largeTransactions.general.summary[1];
                    if (dataCryptoObj.inbound && dataStableObj.inbound)
                        seriesArr = [dataStableObj.inbound, dataCryptoObj.inbound];
                }
            }
            return seriesArr;
        },
        chartsNames(){
            let arrNames = ['Treasuries','All<br>transactions','Small<br>transactions','Large<br>transactions'];
            if (this.seriesTreasures[0] == 0 && this.seriesTreasures[1] == 0)                   arrNames[0] += '<br>No data';
            if (this.seriesAllTransactions[0] == 0 && this.seriesAllTransactions[1] == 0)       arrNames[1] += '<br>No data';
            if (this.seriesSmallTransactions[0] == 0 && this.seriesSmallTransactions[1] == 0)   arrNames[2] += '<br>No data';
            if (this.seriesLargeTransactions[0] == 0 && this.seriesLargeTransactions[1] == 0)   arrNames[3] += '<br>No data';
            return arrNames;
        },
        chartsShowLegends(){
            let showLegends = [true,true,true,true];
            if (this.seriesTreasures[0] == 0 && this.seriesTreasures[1] == 0)                   showLegends[0] = false;
            if (this.seriesAllTransactions[0] == 0 && this.seriesAllTransactions[1] == 0)       showLegends[1] = false;
            if (this.seriesSmallTransactions[0] == 0 && this.seriesSmallTransactions[1] == 0)   showLegends[2] = false;
            if (this.seriesLargeTransactions[0] == 0 && this.seriesLargeTransactions[1] == 0)   showLegends[3] = false;
            return showLegends;
        },
        selectedTransactions(){
            let selectedTransactions = [];
            switch(this.transactionsSize){
                case 'All': selectedTransactions = this.allTransactions; break;
                case 'Small': selectedTransactions = this.smallTransactions; break;
                case 'Large': selectedTransactions =  this.largeTransactions; break;
            }
            return selectedTransactions;
        },
        treasuresColors(){
            return this.darkTheme ? this.chartsColorsDark.treasures : this.chartsColors.treasures;
        },
        standardColors(){
            return this.darkTheme ? this.chartsColorsDark.standard : this.chartsColors.standard;
        }
    },
    methods:{
        changeDay(action){
            // if it's not future day
            if (moment(this.startDate)[action](1,'days').utc().format(moment.HTML5_FMT.DATE) <= moment(new Date().toUTCString()).utc().format(moment.HTML5_FMT.DATE)){
                this.startDate = moment(this.startDate)[action](1,'days').utc().toDate().toUTCString();
                this.endDate = moment(this.endDate)[action](1,'days').utc().toDate().toUTCString();
                this.getData();
            }
        },
        handeTransactionsSize(size){
            this.transactionsSize = size;
        },
        getData(){
            // create object with all required params
            let queryParameters = {
                params:{
                    page:1,
                    startDate:moment(this['startDate']).utc().format('YYYY-MM-DD'),
                    endDate:moment(this['endDate']).utc().format('YYYY-MM-DD'),
                    timeframe:'1d',
                }
            };

            let queryParametersAll = JSON.parse(JSON.stringify(queryParameters));

            let queryParametersSmall = JSON.parse(JSON.stringify(queryParameters));
            queryParametersSmall.params['less_than_usd'] = '950000';

            let queryParametersLarge = JSON.parse(JSON.stringify(queryParameters));
            queryParametersLarge.params['more_than_usd'] = '950000';

            this.chartsLoading = [true,true,true,true,true];
            axios.get('tx/summary',queryParametersAll).then(response => {
                this.chartsLoading[0] = false;
                this.chartsLoading[1] = false;
                if (this.transactionsSize == 'All') this.chartsLoading[4] = false;
                this.allTransactions = response.data;
                // new query for small transactions
                return axios.get('tx/summary',queryParametersSmall); 
            }).then(response => {
                this.chartsLoading[2] = false;
                if (this.transactionsSize == 'Small') this.chartsLoading[4] = false;
                this.smallTransactions = response.data;
                // new query for large transactions
                return axios.get('tx/summary',queryParametersLarge); 
            }).then(response => {
                this.chartsLoading[3] = false;
                if (this.transactionsSize == 'Large') this.chartsLoading[4] = false;
                this.largeTransactions = response.data;
            });
        },
    },
    created(){
        this.getData();
    },
}
</script>>
<style lang="scss" scoped>
.dashboard-page{
    display: flex;
    flex-wrap: wrap;
    .left{
        width: 40%;
        border-right: 1px solid var(--header-br-color);
        @media (max-width: 1100px) {
            width: 100%;
            border-right:none;
        }
        form{
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 0px;
            & > *{
                width: 168px;
                margin-bottom: 15px;
                margin-right: 8px;
                @media (max-width: 500px) {
                    width: 100%;
                    margin-right: 0px;
                    margin-bottom: 22px;
                    &.plusMinusDay{
                        margin-right: 15px;
                    }
                }
            }
        }
        .donuts{
            display:flex;
            flex-wrap: wrap;
            justify-content: space-around;
            & > div{
                width: 50%;
                transition: .3s ease;
                max-width: 200px;
            }
        }
    }
    .right{
        width: 60%;
        padding-left: 45px;
        padding-top: 58px;
        @media (max-width: 1100px) {
            width: 100%;
            padding-left: 0px;
        }
    }
    .loading{
        opacity: 0.3;
        pointer-events: none;
    }
}
</style>